import { Box, Typography } from "@mui/material";
import DOMPurify from "isomorphic-dompurify";
import { forwardRef, memo } from "react";

const ProductMidSectionDescription = forwardRef(({ description }: { description: string }, ref) => {
  return (
    <Box ref={ref}>
      <Typography component="div" whiteSpace="pre-wrap" >
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description, {
              ADD_TAGS: ["iframe"],
              ADD_ATTR: ["src", "webkitallowfullscreen", "mozallowfullscreen", "allowfullscreen"],
            }),
          }}
        ></div>
      </Typography>
    </Box>
  );
});

export default memo(ProductMidSectionDescription);
